module.exports = __webpack_public_path__ + "img/forbid-down-btn.95fd5b3c.svg";